import { getChallengesService } from './challenges';
import { getGamingsService } from './gamings';
import { getConfigsService } from './configs';
import { getImportsService } from './imports';
import { getLibrariesService } from './libraries';
import { getLibraryBooksService } from './library-books';
import { getCacheService } from './cache';
import { getAppEventsService } from '~/db/app-events';
import { getCategoriesService } from '~/db/categories';
import { getMediasService } from '~/db/medias';
import { getPostsService } from '~/db/posts';
import { getProfilesService } from '~/db/profiles';
import { getProgressionsService } from '~/db/progressions';
import { getExerciseInfosService } from '~/db/exercise-infos';
import { getTrophiesService } from '~/db/trophies';
import { getUsersService } from '~/db/users';
import { getAssessmentsService } from '~/db/assessments';
import { getFavoritesService } from '~/db/favorites';

import { getRecommendationsService } from '~/db/recommendations';

import { getRecommendationParametersService } from '~/db/recommendationParameters';

import { getExercisesService } from '~/db/exercises';
import { getExerciseItemsService } from '~/db/exercise-items';

import { getVersionsService } from '~/db/versions';
import { getCoachingStatsService } from '~/db/coaching-stats';
import { getTasksService } from '~/db/tasks';

export const getServices = (db) => {
  const appEventsService = getAppEventsService(db);
  const categoriesService = getCategoriesService(db);
  const mediasService = getMediasService(db);
  const postsService = getPostsService(db);
  const challengesService = getChallengesService(db);
  const gamingsService = getGamingsService(db);
  const configsService = getConfigsService(db);
  const librariesService = getLibrariesService(db);
  const importsService = getImportsService(db);
  const libraryBooksService = getLibraryBooksService(db);
  const profilesService = getProfilesService(db);
  const progressionsService = getProgressionsService(db);
  const trophiesService = getTrophiesService(db);
  const usersService = getUsersService(db);
  const assessmentsService = getAssessmentsService(db);
  const favoritesService = getFavoritesService(db);

  const cacheService = getCacheService(db);

  const exercisesService = getExercisesService(db);
  const exerciseItemsService = getExerciseItemsService(db);

  const versionsService = getVersionsService(db);

  const exerciseInfosService = getExerciseInfosService(db);

  const coachingStatsService = getCoachingStatsService(db);

  const tasksService = getTasksService(db);

  const recommendationsService = getRecommendationsService(db);

  const recommendationParametersService =
    getRecommendationParametersService(db);

  return {
    appEventsService,
    categoriesService,
    mediasService,
    postsService,
    challengesService,
    gamingsService,
    configsService,
    librariesService,
    importsService,
    libraryBooksService,
    profilesService,
    progressionsService,
    trophiesService,
    usersService,
    assessmentsService,
    favoritesService,
    cacheService,
    exercisesService,
    exerciseItemsService,
    versionsService,
    exerciseInfosService,
    coachingStatsService,
    tasksService,
    recommendationsService,
    recommendationParametersService,
  };
};
